import { render, staticRenderFns } from "./ViewEmailDataCard.vue?vue&type=template&id=3cef30d5&scoped=true"
import script from "./ViewEmailDataCard.vue?vue&type=script&lang=js"
export * from "./ViewEmailDataCard.vue?vue&type=script&lang=js"
import style0 from "./ViewEmailDataCard.vue?vue&type=style&index=0&id=3cef30d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef30d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpansionPanelContent,VIcon,VRow})
